import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { environment } from '../environments/environment';
import { FeatureService } from './feature.service';
import { UserClaim } from './features/activities/shared/models/user-claim.enum';
@Component({
  selector: 'link-bar',
  templateUrl: `link-bar.component.html`,
  styleUrls: ['link-bar.component.css'],
})
export class LinkBarComponent {
  @Input() links: Array<{
    label: string;
    route: any;
    angulartics: any;
    active: boolean;
  }> = [];
  @Input() applications: Array<any> = [];
  @Output() navTo: EventEmitter<string> = new EventEmitter();
  @ViewChild('userMenu') public userMenu;
  public menuToggled = false;
  userClaim = UserClaim;
  constructor(
    private router: Router,
    private angulartics: Angulartics2GoogleAnalytics,
    private featureService: FeatureService
  ) { }
  public toggleMenu($event): void {
    if ($event) {
      $event.stopPropagation();
      $event.preventDefault();
    }
    this.menuToggled = !this.menuToggled;
  }

  public navigateTo(location: string): void {
    this.closeMenu();
    this.navTo.emit(location);
  }

  public travelLink(link, $event): void {
    $event.preventDefault();
    if (link.angulartics) {
      this.angulartics.eventTrack(link.angulartics.action, {
        label: link.angulartics.label,
        MembershipType: this.featureService.GaMemberShipType,
      });
    }
    this.router.navigate(link.route);
  }

  public navigateToUrl(url) {
    window.location = url;
  }

  public closeMenu(): void {
    this.menuToggled = false;
  }

  public navigateToAppSwitcher() {
    window.location.href = environment.app_switcher_url;
  }

  private removeSelection() {
    for (let i = 0; i < this.links.length; i++) {
      this.links[i].active = false;
    }
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    if (this.userMenu && this.userMenu.nativeElement) {
      const clickedInside = this.userMenu.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.menuToggled = false;
      }
    }
  }
}
